import React, { useEffect, useState,useRef } from "react";
import "./questionpanel.css";
import QuestionList from "../question_list";
import useWindowDimensions from "../../../services/useWindowDimensions";
import { connect } from "react-redux";
import saveAndNext from "../../../services/saveAndNext";
import Confirm from "../../../components/confirm";
import MandatoryQuestion from "../../../components/mandatory_question_popup";
import changeLanguage from "../../../assets/icons/changeLanguage.svg";
import Slider from "../../../components/Slider";
import { useTranslation } from "react-i18next";

const QuestionPanel = (props) => {
  const { t, i18n } = useTranslation();
  const [subjectid, setSubjectId] = useState("");
  const { width } = useWindowDimensions();
  const [show, setShow] = useState(false);
  const [showMadetry, setshowMadetry] = useState(false);

  const isNEET = props?.state?.test_data?.is_neet_test === 1;
  const isSecTime = props?.state?.test_data?.is_sec_time === 1;
  const selectedLanguage = props.languageSelected || "English";

  // Always available UI languages (these affect static text)
  // const alwaysAvailableLanguages = [
  //   { id: 'en', title: 'English', i18nCode: 'en' },
  //   { id: 'fr', title: 'Français', i18nCode: 'fr' },
  //   { id: 'de', title: 'Deutsch', i18nCode: 'de' }
  // ];

  // // All possible UI languages mapping
  // const allUiLanguages = [
  //   { id: 'en', title: 'English', i18nCode: 'en' },
  //   { id: 'hi', title: 'हिन्दी', i18nCode: 'hi' },
  //   { id: 'fr', title: 'Français', i18nCode: 'fr' },
  //   { id: 'de', title: 'Deutsch', i18nCode: 'de' },
  //   { id: 'kn', title: 'ಕನ್ನಡ', i18nCode: 'kn' },
  //   { id: 'bn', title: 'বাংলা', i18nCode: 'bn' },
  //   { id: 'mr', title: 'मराठी', i18nCode: 'mr' },
  //   { id: 'gu', title: 'ગુજરાતી', i18nCode: 'gu' },
  //   { id: 'te', title: 'తెలుగు', i18nCode: 'te' },
  //   { id: 'ta', title: 'தமிழ்', i18nCode: 'ta' },
  //   { id: 'or', title: 'ଓଡ଼ିଆ', i18nCode: 'or' }
  // ];
  // console.log("select", selectedLanguage);
  useEffect(() => {
    const savedIndex = parseInt(localStorage.getItem("activeQuesInd"));
    const savedSection = localStorage.getItem("selectedSection");
    if (!isNaN(savedIndex)) {
      props.dispatch({ type: "ACTIVE_QUESTION_NUMBER", activeQuesInd: savedIndex });
      // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", savedIndex, "from <quesp1>");

    }
    if (savedSection) {
      props.dispatch({ type: "SET_SELECTED_SECTION", selectedSection: savedSection });
    }
  }, []);

  useEffect(() => {
    const preferredLang = localStorage.getItem("preferred_language");
    if (preferredLang) {
      props.dispatch({
        type: "CHANGES_LANGUAGE",
        languageSelected: parseInt(preferredLang),
      });
    } else {
      // fallback to English
      props.dispatch({
        type: "CHANGES_LANGUAGE",
        languageSelected: 1,
      });
      localStorage.setItem("preferred_language", 1);
    }
  }, []);
  

  useEffect(() => {
    if (
      isNEET &&
      !props.state.selectedSection &&
      Array.isArray(props.state.subjects_data) &&
      props.state.subjects_data.length > 0
    ) {
      const first = props.state.subjects_data[0];
      const defaultSection = `${first.subject_id}#${first.section_id}`;
      props.dispatch({
        type: "SET_SELECTED_SECTION",
        selectedSection: defaultSection,
      });
    }
  }, [props.state.selectedSection, props.state.subjects_data]);

  useEffect(() => {
    if (!isNEET || !isSecTime || !props.state.selectedSection) return;
  
    const activeQ = props.ques_data?.[props.state.activeQuesInd];
    const currentKey = activeQ
      ? `${activeQ.subject_id}#${activeQ.section_id}`
      : null;
    const newKey = props.state.selectedSection;
  
    if (currentKey && currentKey === newKey) return;
  
    const index = props.ques_data.findIndex(
      (q) => `${q.subject_id}#${q.section_id}` === newKey
    );
  
    if (index !== -1) {
      props.dispatch({
        type: "ACTIVE_QUESTION_NUMBER",
        activeQuesInd: index,
      });
      localStorage.setItem("activeQuesInd", index);
      // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", index, "from <quesp2>");

    }
  
    setSubjectId(newKey);
  }, [props.state.selectedSection]); // ✅ only depends on section change
  
  
  
  useEffect(() => {
    const activeQ = props.ques_data?.[props.state.activeQuesInd];

    if (isNEET) {
      if (isSecTime && props.state.selectedSection) {
        setSubjectId(props.state.selectedSection);
      } else if (!isSecTime && activeQ) {
        setSubjectId(`${activeQ.subject_id}#${activeQ.section_id}`);
      }
    } else if (activeQ) {
      setSubjectId(activeQ.subject_id);
    }
  }, [props.state.test_data, props.state.selectedSection, props.state.activeQuesInd, props.ques_data]);

  const prevSubjectIdRef = useRef("");

  useEffect(() => {
    if (!subjectid || !isNEET) return;

    const activeQ = props.ques_data?.[props.state.activeQuesInd];
    const currentKey = `${activeQ?.subject_id}#${activeQ?.section_id}`;

    if (props.state.activeQuesInd === -1) {
      const index = props.ques_data.findIndex(
        (obj) => `${obj.subject_id}#${obj.section_id}` === subjectid
      );
      if (index !== -1) {
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: index,
          
        });
        // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", index, "from <quesp3>");

      }
    }
  }, [subjectid]);


  
  useEffect(() => {
    const quesData = props.state.ques_data;
  
    if (!Array.isArray(quesData) || quesData.length === 0) return;
  
    const quesLength = quesData.length;
  
    // 1. Initialize questionstatus
    if (!Array.isArray(props.state.questionstatus) || props.state.questionstatus.length !== quesLength) {
      const statusInit = quesData.map((q) => ({
        ques_id: q.ques_id,
        status_number: 1,
      }));
      props.dispatch({
        type: "CHANGES_STATUS",
        questionstatus: statusInit,
      });
      props.dispatch({
        type: "GLOBAL_CHANGES_STATUS",
        questionstatus: statusInit,
      });
    }
  
    // 2. Initialize answers_json
    if (!Array.isArray(props.state.answers_json) || props.state.answers_json.length !== quesLength) {
      props.dispatch({
        type: "CHANGES_ANSWER_JSON",
        answers_json: Array(quesLength).fill("-1"),
      });
    }
  
    // 3. Initialize subjective_answer (only if empty, preserve loaded data)
    if (!Array.isArray(props.state.subjective_answer) || props.state.subjective_answer.length === 0) {
      props.dispatch({
        type: "CHANGES_SUBJECTIVE_ANSWER",
        subjective_answer: Array(quesLength).fill("-1"),
      });
    } else if (props.state.subjective_answer.length !== quesLength) {
      // Resize array while preserving existing data
      const resized = [...props.state.subjective_answer];
      while (resized.length < quesLength) {
        resized.push("-1");
      }
      props.dispatch({
        type: "CHANGES_SUBJECTIVE_ANSWER",
        subjective_answer: resized,
      });
    }
  
    // 4. Initialize is_bookmarked
    if (!Array.isArray(props.state.is_bookmarked) || props.state.is_bookmarked.length !== quesLength) {
      props.dispatch({
        type: "CHANGES_BOOKMARK",
        is_bookmarked: Array(quesLength).fill("0"),
      });
    }
  
    // 5. 🔄 REBUILD subjects_data.questions for resume case
    if (Array.isArray(props.state.subjects_data) && props.state.subjects_data.length > 0) {
      const updatedSubjectsData = props.state.subjects_data.map(section => {
        const sectionQuestions = quesData.filter(
          q => q.subject_id === section.subject_id && q.section_id === section.section_id
        );
        return {
          ...section,
          questions: sectionQuestions // ✅ attach question list
        };
      });
      // console.log("🔍 subjects_data after rebuild:", updatedSubjectsData.map(sec => ({
      //   section_title: sec.section_title,
      //   attempt_limit: sec.attempt_questions,
      //   questions_count: sec.questions.length
      // })));
      props.dispatch({
        type: "UPDATE_SUBJECTS_DATA",
        subjects_data: updatedSubjectsData
      });
    }
  
  }, []);

  // Language inheritance useEffect - sync i18n with localStorage language from instructions
  useEffect(() => {
    const savedI18nLanguage = localStorage.getItem('i18nextLng');
    if (savedI18nLanguage && i18n.language !== savedI18nLanguage) {
      i18n.changeLanguage(savedI18nLanguage);
    }
  }, [i18n]);

  const SavendNext = async () => {
    const isNEET = props?.testPanelData?.is_neet_test === 1;
    const isSecTime = props?.testPanelData?.is_sec_time === 1;
    const isMandatory = props?.testPanelData?.test_settings?.is_all_mandatory_questions === 1;
  
    const activeIndex = props.state.activeQuesInd;
    const nextIndex = activeIndex + 1;
  
    const activeQues = props.activeQuesData;
    const answers = props.state.answers_json || [];
    const subjectiveAns = props.state.subjective_answer || [];
    const quesData = props.state.ques_data || [];
  
    // local questionStatus (fallback to building from quesData if redux empty)
    let questionStatus =
      Array.isArray(props.state.questionstatus) && props.state.questionstatus.length
        ? [...props.state.questionstatus]
        : quesData.map((q) => ({ ques_id: q.ques_id, status_number: 1 }));
  
    const nextQues = quesData[nextIndex];
  
    let subjectid = props.state.selectedSection;
    if (!subjectid && activeQues) {
      subjectid = `${activeQues.subject_id}#${activeQues.section_id}`;
    }
  
    if (!activeQues || !Array.isArray(quesData) || typeof activeIndex !== "number") {
      console.warn("❌ Invalid active question data");
      return;
    }
  
    // ---- 1) Capture previous status so we can detect a 'new' attempt ----
    const prevStatus =
      (Array.isArray(props.state.questionstatus) &&
        props.state.questionstatus[activeIndex] &&
        props.state.questionstatus[activeIndex].status_number) ||
      questionStatus[activeIndex]?.status_number ||
      1;
  
    // ---- 2) Compute the new local status for the current question (don't dispatch yet) ----
    const givenAns = answers[activeIndex];
    const isSubjective = activeQues?.ques_type_id === 2;
  
    // determine newStatusCandidate (2 = attempted/unanswered, 4 = answered)
    let newStatusCandidate = questionStatus[activeIndex]?.status_number ?? 1;
    if (givenAns !== "-1") {
      if (isSubjective) {
        if (typeof givenAns === "string" && givenAns.includes("_")) {
          const idx = givenAns.split("_").pop();
          if (subjectiveAns?.[idx] !== "-1") {
            newStatusCandidate = 4;
          } else if (isMandatory) {
            setshowMadetry(true);
            return;
          }
        } else if (isMandatory) {
          setshowMadetry(true);
          return;
        }
      } else {
        newStatusCandidate = 4;
      }
    } else {
      newStatusCandidate = 2;
      if (isMandatory) {
        setshowMadetry(true);
        return;
      }
    }
  
    questionStatus[activeIndex] = {
      ...(questionStatus[activeIndex] || {}),
      ques_id: questionStatus[activeIndex]?.ques_id ?? activeQues.ques_id,
      status_number: newStatusCandidate,
    };
  
    // ---- 3) NEET attempt-limit check (use local questionStatus and ques_data) ----
    if (isNEET && subjectid?.includes("#") && !isMandatory) {  // <-- ✅ skip if mandatory
      const [subId, secId] = subjectid.split("#");
  
      // find section meta (attempt_questions) from subjects_data if present
      const sectionMeta = Array.isArray(props.state.subjects_data)
        ? props.state.subjects_data.find(
            (it) => String(it.subject_id) === String(subId) && String(it.section_id) === String(secId)
          )
        : null;
  
      // build attemptedIds from ques_data (resume-safe)
      const attemptedIds = quesData
        .filter(
          (q) => String(q.subject_id) === String(subId) && String(q.section_id) === String(secId)
        )
        .map((q) => String(q.ques_id));
  
      const attemptedSet = new Set(attemptedIds);
  
      // count answered (use local questionStatus); normalize ids to string
      const answeredCount = questionStatus.reduce((acc, qs) => {
        return attemptedSet.has(String(qs.ques_id)) && (qs.status_number === 4 || qs.status_number === 5)
          ? acc + 1
          : acc;
      }, 0);
  
      // console.log("DEBUG SavendNext: prevStatus", prevStatus);
      // console.log("DEBUG SavendNext: attemptedIds", attemptedIds);
      // console.log("DEBUG SavendNext: new local answeredCount", answeredCount);
      // console.log("DEBUG SavendNext: newStatusCandidate", newStatusCandidate, "questionStatus[activeIndex]", questionStatus[activeIndex]);
  
      // If this action created a NEW answer (previously not answered) and count exceeds limit -> block & rollback
      if (
        sectionMeta?.attempt_questions &&
        prevStatus !== 4 &&
        prevStatus !== 5 && // previous was NOT answered
        answeredCount > Number(sectionMeta.attempt_questions) // local count includes the current change
      ) {
        alert(
          t('test.attemptLimitMessageSimple', { limit: sectionMeta.attempt_questions })
        );
  
        // rollback local change (do not dispatch)
        questionStatus[activeIndex].status_number = prevStatus;
        return;
      }
    }
  
    // ---- 4) Commit status to Redux now that checks passed ----
    props.dispatch({
      type: "CHANGES_STATUS",
      questionstatus: [...questionStatus],
    });
    props.dispatch({
      type: "GLOBAL_CHANGES_STATUS",
      questionstatus: [...questionStatus],
    });
  
    // ---- 5) Save to server ----
    await saveAndNext(props);
  
    // ---- 6) Navigation (same as before) ----
    if (!nextQues) {
      console.warn("⚠️ No next question found.");
      return;
    }
  
    const nextKey = `${nextQues.subject_id}#${nextQues.section_id}`;
    const currentKey = subjectid?.trim();
  
    if (isNEET && isSecTime) {
      if (nextKey === currentKey) {
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: nextIndex,
        });
        // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", nextIndex, "from <quesP4>");

        localStorage.setItem("activeQuesInd", nextIndex);
      } else {
        const currentSectionQues = quesData.filter(
          (q) => `${q.subject_id}#${q.section_id}` === currentKey
        );
        const lastInCurrentSection = currentSectionQues[currentSectionQues.length - 1];
        if (lastInCurrentSection?.ques_id === activeQues?.ques_id) {
          console.warn("You are already at the last question of this section.");
          return;
        }
      }
      return;
    }
  
    if (nextKey !== currentKey && props.state.selectedSection !== nextKey) {
      props.dispatch({
        type: "SET_SELECTED_SECTION",
        selectedSection: nextKey,
      });
      localStorage.setItem("selectedSection", nextKey);
    }
    
  
    props.dispatch({
      type: "ACTIVE_QUESTION_NUMBER",
      activeQuesInd: nextIndex,
    });
    localStorage.setItem("activeQuesInd", nextIndex);
    // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", nextIndex, "from <quesp5>");

  };
  
  
  
  
  
  
  
  
  
  
  
  
  
  const Save = async () => {
    if (props?.testPanelData?.is_neet_test == 1) {
      let count = 0;
      let attemtedQus = props?.state?.subjects_data.filter((item) => {
        return "" + item?.subject_id + "#" + item?.section_id == subjectid;
      });
      let quest = attemtedQus[0]?.questions?.map((item) => item?.ques_id);
  
      for (let x of props?.state?.questionstatus) {
        if (
          quest.includes(Number(x?.ques_id)) &&
          (x?.status_number == 4 || x?.status_number == 5)
        ) {
          count++;
        }
      }
  
      // ✅ Added check for resume case also
      const currentQuesStatus = props?.state?.questionstatus.find(
        (item) => item?.ques_id == props?.activeQuesData?.ques_id
      );
      // console.log("current status ",currentQuesStatus, attemtedQus[0]?.attempt_questions)
      // console.log("answeerd count",count)
      if (
        attemtedQus[0]?.attempt_questions &&
        count + 1 > attemtedQus[0]?.attempt_questions &&
        currentQuesStatus?.status_number != 4 &&
        currentQuesStatus?.status_number != 5
      ) {
        alert(
          t('test.attemptLimitMessage', { limit: attemtedQus[0]?.attempt_questions })
        );
      } else {
        if (props.state.answers_json[props.state.activeQuesInd] !== "-1") {
          if (props.activeQuesData.ques_type_id == 2) {
            let index = props.state.answers_json[props.state.activeQuesInd]
              .split("_")
              .pop();
            if (props.state.subjective_answer[index] != "-1") {
              let questionStatus = props.state.questionstatus;
              if (
                questionStatus[props.state.activeQuesInd].ques_id ==
                  props.activeQuesData.ques_id &&
                questionStatus[props.state.activeQuesInd].status_number != 4
              ) {
                questionStatus[props.state.activeQuesInd].status_number = 4;
              }
              props.dispatch({
                type: "CHANGES_STATUS",
                questionstatus: [...questionStatus],
              });
              props.dispatch({
                type: "GLOBAL_CHANGES_STATUS",
                questionstatus: [...questionStatus],
              });
  
              await saveAndNext(props);
            } else if (
              props.testPanelData.test_settings.is_all_mandatory_questions === 1
            ) {
              setshowMadetry(true);
            } else {
              let questionStatus = props.state.questionstatus;
              questionStatus[props.state.activeQuesInd + 1].status_number = 2;
              await props.dispatch({
                type: "CHANGES_STATUS",
                questionstatus: [...questionStatus],
              });
              props.dispatch({
                type: "GLOBAL_CHANGES_STATUS",
                questionstatus: [...questionStatus],
              });
  
              await saveAndNext(props);
            }
          } else {
            let questionStatus = props.state.questionstatus;
            if (
              questionStatus[props.state.activeQuesInd].ques_id ==
                props.activeQuesData.ques_id &&
              questionStatus[props.state.activeQuesInd].status_number != 4
            ) {
              questionStatus[props.state.activeQuesInd].status_number = 4;
            }
            props.dispatch({
              type: "CHANGES_STATUS",
              questionstatus: [...questionStatus],
            });
            props.dispatch({
              type: "GLOBAL_CHANGES_STATUS",
              questionstatus: [...questionStatus],
            });
  
            await saveAndNext(props);
          }
        } else if (
          props.testPanelData.test_settings.is_all_mandatory_questions === 1
        ) {
          setshowMadetry(true);
        } else {
          let questionStatus = props.state.questionstatus;
          questionStatus[props.state.activeQuesInd + 1].status_number = 2;
          await props.dispatch({
            type: "CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });
          props.dispatch({
            type: "GLOBAL_CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });
  
          await saveAndNext(props);
        }
      }
    } else {
      if (props.state.answers_json[props.state.activeQuesInd] !== "-1") {
        if (props.activeQuesData.ques_type_id == 2) {
          let index = props.state.answers_json[props.state.activeQuesInd]
            .split("_")
            .pop();
          if (props.state.subjective_answer[index] != "-1") {
            let questionStatus = props.state.questionstatus;
            if (
              questionStatus[props.state.activeQuesInd].ques_id ==
                props.activeQuesData.ques_id &&
              questionStatus[props.state.activeQuesInd].status_number != 4
            ) {
              questionStatus[props.state.activeQuesInd].status_number = 4;
            }
            props.dispatch({
              type: "CHANGES_STATUS",
              questionstatus: [...questionStatus],
            });
            props.dispatch({
              type: "GLOBAL_CHANGES_STATUS",
              questionstatus: [...questionStatus],
            });
  
            await saveAndNext(props);
          } else if (
            props.testPanelData.test_settings.is_all_mandatory_questions === 1
          ) {
            setshowMadetry(true);
          }
        } else {
          let questionStatus = props.state.questionstatus;
          if (
            questionStatus[props.state.activeQuesInd].ques_id ==
              props.activeQuesData.ques_id &&
            questionStatus[props.state.activeQuesInd].status_number != 4
          ) {
            questionStatus[props.state.activeQuesInd].status_number = 4;
          }
          props.dispatch({
            type: "CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });
          props.dispatch({
            type: "GLOBAL_CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });
  
          await saveAndNext(props);
        }
      } else if (
        props.testPanelData.test_settings.is_all_mandatory_questions === 1
      ) {
        setshowMadetry(true);
      } else {
        let questionStatus = props.state.questionstatus;
        questionStatus[props.state.activeQuesInd + 1].status_number = 2;
        await props.dispatch({
          type: "CHANGES_STATUS",
          questionstatus: [...questionStatus],
        });
        props.dispatch({
          type: "GLOBAL_CHANGES_STATUS",
          questionstatus: [...questionStatus],
        });
  
        await saveAndNext(props);
      }
    }
  };
  
  
  // const Save = async () => {
  //   if (props?.testPanelData?.is_neet_test == 1) {
  //     let count = 0;
  //     let attemtedQus = props?.state?.subjects_data.filter((item, index) => {
  //       return "" + item?.subject_id + "#" + item?.section_id == subjectid;
  //     });
  //     let quest = attemtedQus[0]?.questions?.map((item, index) => {
  //       return item?.ques_id;
  //     });
  //     for (let x of props?.state?.questionstatus) {
  //       if (
  //         quest.includes(Number(x?.ques_id)) &&
  //         (x?.status_number == 4 || x?.status_number == 5)
  //       ) {
  //         count++;
  //       }
  //     }

  //     if (count + 1 > attemtedQus[0]?.attempt_questions) {
  //       alert(
  //         `The maximum number of attemptable questions for this section is ${attemtedQus[0]?.attempt_questions}. To attempt this question please un-answer other questions from this section or move to the next section if available, otherwise submit the test`
  //       );
  //     } else {
  //       if (props.state.answers_json[props.state.activeQuesInd] !== "-1") {
  //         if (props.activeQuesData.ques_type_id == 2) {
  //           let index = props.state.answers_json[props.state.activeQuesInd]
  //             .split("_")
  //             .pop();
  //           if (props.state.subjective_answer[index] != "-1") {
  //             let questionStatus = props.state.questionstatus;
  //             if (
  //               questionStatus[props.state.activeQuesInd].ques_id ==
  //                 props.activeQuesData.ques_id &&
  //               questionStatus[props.state.activeQuesInd].status_number != 4
  //             ) {
  //               questionStatus[props.state.activeQuesInd].status_number = 4;
  //             }
  //             props.dispatch({
  //               type: "CHANGES_STATUS",
  //               questionstatus: [...questionStatus],
  //             });
  //             await saveAndNext(props);
  //             // await setShow(true);
  //           } else if (
  //             props.testPanelData.test_settings.is_all_mandatory_questions === 1
  //           ) {
  //             setshowMadetry(true);
  //           } else {
  //             let questionStatus = props.state.questionstatus;
  //             questionStatus[props.state.activeQuesInd].status_number = 2;
  //             await props.dispatch({
  //               type: "CHANGES_STATUS",
  //               questionstatus: [...questionStatus],
  //             });
  //             await saveAndNext(props);
  //             // await setShow(true);
  //           }
  //         } else {
  //           let questionStatus = props.state.questionstatus;
  //           if (
  //             questionStatus[props.state.activeQuesInd].ques_id ==
  //               props.activeQuesData.ques_id &&
  //             questionStatus[props.state.activeQuesInd].status_number != 4
  //           ) {
  //             questionStatus[props.state.activeQuesInd].status_number = 4;
  //           }
  //           props.dispatch({
  //             type: "CHANGES_STATUS",
  //             questionstatus: [...questionStatus],
  //           });
  //           await saveAndNext(props);
  //           // await setShow(true);
  //         }
  //       } else if (
  //         props.testPanelData.test_settings.is_all_mandatory_questions === 1
  //       ) {
  //         setshowMadetry(true);
  //       } else {
  //         let questionStatus = props.state.questionstatus;
  //         questionStatus[props.state.activeQuesInd].status_number = 2;
  //         await props.dispatch({
  //           type: "CHANGES_STATUS",
  //           questionstatus: [...questionStatus],
  //         });
  //         await saveAndNext(props);
  //         // await setShow(true);
  //       }
  //     }
  //   } else {
  //     if (
  //       props.state.answers_json[props.state.activeQuesInd] !== "-1" &&
  //       !props.state.answers_json.some((value) => value == "-1")
  //     ) {
  //       if (props.activeQuesData.ques_type_id == 2) {
  //         let index = props.state.answers_json[props.state.activeQuesInd]
  //           .split("_")
  //           .pop();
  //         if (props.state.subjective_answer[index] != "-1") {
  //           let questionStatus = props.state.questionstatus;
  //           if (
  //             questionStatus[props.state.activeQuesInd].ques_id ==
  //               props.activeQuesData.ques_id &&
  //             questionStatus[props.state.activeQuesInd].status_number != 4
  //           ) {
  //             questionStatus[props.state.activeQuesInd].status_number = 4;
  //           }
  //           props.dispatch({
  //             type: "CHANGES_STATUS",
  //             questionstatus: [...questionStatus],
  //           });
  //           await saveAndNext(props);
  //           // await setShow(true);
  //         } else if (
  //           props.testPanelData.test_settings.is_all_mandatory_questions === 1
  //         ) {
  //           setshowMadetry(true);
  //         } else {
  //           let questionStatus = props.state.questionstatus;
  //           questionStatus[props.state.activeQuesInd + 1].status_number = 2;
  //           await props.dispatch({
  //             type: "CHANGES_STATUS",
  //             questionstatus: [...questionStatus],
  //           });
  //           await saveAndNext(props);
  //           // await setShow(true);
  //         }
  //       } else {
  //         let questionStatus = props.state.questionstatus;
  //         if (
  //           questionStatus[props.state.activeQuesInd].ques_id ==
  //             props.activeQuesData.ques_id &&
  //           questionStatus[props.state.activeQuesInd].status_number != 4
  //         ) {
  //           questionStatus[props.state.activeQuesInd].status_number = 4;
  //         }
  //         props.dispatch({
  //           type: "CHANGES_STATUS",
  //           questionstatus: [...questionStatus],
  //         });
  //         await saveAndNext(props);
  //         // await setShow(true);
  //       }
  //     } else if (
  //       props.testPanelData.test_settings.is_all_mandatory_questions === 1
  //     ) {
  //       setshowMadetry(true);
  //     } else {
  //       let questionStatus = props.state.questionstatus;
  //       questionStatus[props.state.activeQuesInd].status_number = 2;
  //       await props.dispatch({
  //         type: "CHANGES_STATUS",
  //         questionstatus: [...questionStatus],
  //       });
  //       await saveAndNext(props);
  //       // await setShow(true);
  //     }
  //   }
  // };
  const MarkedForReview = async () => {
    // console.log("▶️ MarkedForReview triggered");
  
    const isNEET = props?.testPanelData?.is_neet_test == 1;
    const isSecTime = props?.testPanelData?.is_sec_time == 1;
    const selectedSection = props?.state?.selectedSection;
    const activeIndex = props?.state?.activeQuesInd;
    const activeQues = props?.activeQuesData;
    const quesData = props.state.ques_data || [];
  
    const questionStatus = Array.isArray(props?.state?.questionstatus)
      ? [...props.state.questionstatus]
      : quesData.map((q) => ({ ques_id: q.ques_id, status_number: 1 }));
  
    let subjectKey = props?.state?.selectedSection;
    if (!subjectKey && activeQues) {
      subjectKey = `${activeQues.subject_id}#${activeQues.section_id}`;
    }
  
    // console.log("🔑 subjectid:", subjectKey);
    // console.log("🧠 activeQuesData:", activeQues);
  
    if (isNEET) {
      const attemptedQus = props?.state?.subjects_data?.filter(
        (item) => `${item?.subject_id}#${item?.section_id}` === subjectKey
      );
  
      if (!attemptedQus || attemptedQus.length === 0) {
        console.error("❌ attemptedQus not found for subjectKey:", subjectKey);
        return;
      }
  
      const quesList = attemptedQus[0]?.questions;
      if (!Array.isArray(quesList)) {
        console.error("❌ questions list not available for this section.");
        return;
      }
  
      const quesIds = quesList.map((q) => q?.ques_id);
      // console.log("🟩 Question IDs in section:", quesIds);
  
      let count = 0;
      for (let qStatus of questionStatus) {
        if (
          quesIds.includes(Number(qStatus?.ques_id)) &&
          (qStatus?.status_number === 4 || qStatus?.status_number === 5)
        ) {
          count++;
        }
      }
  
   
      // console.log("🟨 Attempted count:", count);
      // console.log("🟨 Allowed max:", attemptedQus[0]?.attempt_questions);
  
      const attemptLimit = attemptedQus[0]?.attempt_questions;
      const currentQStatus = questionStatus.find(
        (q) => q?.ques_id === activeQues?.ques_id
      );
      
      // Only run restriction check if a positive attempt limit is set
      const isMandatory = props?.testPanelData?.test_settings?.is_all_mandatory_questions === 1;

      if (!isMandatory && attemptLimit) {
        const isAlreadyCounted =
          currentQStatus?.status_number === 4 || currentQStatus?.status_number === 5;
      
        if (!isAlreadyCounted && count + 1 > attemptLimit) {
          alert(
            t('test.attemptLimitMessageSimple', { limit: attemptLimit })
          );
          return;
        }
      }
      
      
      const rawAnswers = props.state.answers_json;
      const answers = Array.isArray(rawAnswers)
        ? rawAnswers
        : typeof rawAnswers === "string"
        ? rawAnswers.split(",")
        : [];
  
      if (!answers || typeof answers[activeIndex] === "undefined") {
        console.error("❌ Invalid answers for index:", activeIndex);
        return;
      }
  
      const ans = answers[activeIndex];
      if (ans === "-1" || ans === -1) {
        questionStatus[activeIndex].status_number = 3;
      } else {
        questionStatus[activeIndex].status_number = 5;
      }
  
      props.dispatch({
        type: "CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });
      props.dispatch({
        type: "GLOBAL_CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });
      
      await saveAndNext(props);
  
      // ✅ Safe navigation logic
      const nextQ = quesData[activeIndex + 1];
  
      if (!nextQ) {
        console.warn("🛑 No next question available.");
        return;
      }
  
      const nextKey = `${nextQ.subject_id}#${nextQ.section_id}`;
      const currentKey = subjectKey;
  
      if (isSecTime) {
        if (nextKey === currentKey) {
          props.dispatch({
            type: "ACTIVE_QUESTION_NUMBER",
            activeQuesInd: activeIndex + 1,
          });
          // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", activeIndex+1, "from <quesp6>");

          localStorage.setItem("activeQuesInd", activeIndex + 1);
        } else {
          console.warn("⛔ Skipping navigation to next section in section-wise timer mode.");
        }
      } else {
        if (nextKey !== currentKey && props.state.selectedSection !== nextKey) {
          props.dispatch({
            type: "SET_SELECTED_SECTION",
            selectedSection: nextKey,
          });
          localStorage.setItem("selectedSection", nextKey);
        }
      
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: activeIndex + 1,
        });
        localStorage.setItem("activeQuesInd", activeIndex + 1);
        // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", activeIndex+1, "from <quesp7>");

      }
      
  
    } else {
      // 🔁 Non-NEET logic
      const rawAnswers = props.state.answers_json;
      const answers = Array.isArray(rawAnswers)
        ? rawAnswers
        : typeof rawAnswers === "string"
        ? rawAnswers.split(",")
        : [];
  
      const ans = answers[activeIndex];
      if (ans === "-1" || ans === -1) {
        questionStatus[activeIndex].status_number = 3;
      } else {
        questionStatus[activeIndex].status_number = 5;
      }
  
      props.dispatch({
        type: "CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });
      props.dispatch({
        type: "GLOBAL_CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });
      
      await saveAndNext(props);
  
      if (activeIndex + 1 < quesData.length) {
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: activeIndex + 1,
        });
        localStorage.setItem("activeQuesInd", activeIndex + 1);
        // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", activeIndex+1, "from <quesp8>");

      }
    }
  };
  
  
  

  const ClearResponse = () => {
    if (props.activeQuesData.ques_type_id != 2) {
      let arr = Array.isArray(props.state.answers_json)
        ? props.state.answers_json
        : props.state.answers_json.split(",");
      let ind = props.state.activeQuesInd;
      arr[ind] = "-1";
      props.dispatch({ type: "SET_ANSWER", answers_json: [...arr] });
      let questionStatus = props.state.questionstatus;
      questionStatus[ind].status_number = 2;
      props.dispatch({
        type: "CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });
      props.dispatch({
        type: "GLOBAL_CHANGES_STATUS",
        questionstatus: [...questionStatus],
      });

      saveAndNext(props);
    } else {
      // Validate subjective answer reference before parsing
      const answerRef = props.state.answers_json[props.state.activeQuesInd];
      if (answerRef && answerRef !== "-1" && answerRef.includes("_")) {
        let subIndex = Number(answerRef.split("_").pop());
        if (props.state.subjective_answer[subIndex] != "-1") {
          let arr = props.state.subjective_answer;
          let ind = props.state.activeQuesInd;
          arr[subIndex] = "-1";
          props.dispatch({
            type: "SUBJECTIVE_ANSWERS",
            subjective_answer: [...arr],
          });
          let questionStatus = props.state.questionstatus;
          questionStatus[ind].status_number = 2;
          props.dispatch({
            type: "CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });
          props.dispatch({
            type: "GLOBAL_CHANGES_STATUS",
            questionstatus: [...questionStatus],
          });

          saveAndNext(props);
        }
      }
    }
  };
  const onPreview = () => {
    // console.log("⬅️ Previous clicked");
  
    const isNEET = props?.state?.test_data?.is_neet_test == 1;
    const isSecTime = props?.state?.test_data?.is_sec_time == 1;
    const activeIndex = props?.state?.activeQuesInd;
    const quesData = props?.state?.ques_data;
    const selectedSection = props?.state?.selectedSection;
  
    if (activeIndex <= 0) {
      console.warn("⛔ Already at first question");
      return;
    }
  
    const prevQ = quesData[activeIndex - 1];
    const prevKey = `${prevQ?.subject_id}#${prevQ?.section_id}`;
  
    if (!prevQ) {
      console.warn("❌ No previous question found.");
      return;
    }
  
    if (!isNEET || !isSecTime || prevKey === selectedSection) {
      props.dispatch({
        type: "ACTIVE_QUESTION_NUMBER",
        activeQuesInd: activeIndex - 1,
      });
    } else {
      console.warn("🔒 Previous question is in a different section.");
      // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", activeIndex-1, "from <filename>");

    }
  };

  // Combined language change function for both UI and questions
  // const handleLanguageChange = (e) => {
  //   const selectedValue = e.target.value;

  //   // Check if it's a UI language (from our complete list)
  //   const uiLang = allUiLanguages.find(lang => lang.id === selectedValue);
  //   if (uiLang) {
  //     // Change UI language (static text)
  //     i18n.changeLanguage(uiLang.i18nCode);
  //     localStorage.setItem('i18nextLng', uiLang.i18nCode);
  //   }

  //   // Also handle question language change if changeLanguage function exists
  //   if (typeof props.changeLanguage === "function") {
  //     props.changeLanguage(e);
  //   }
  // };

  // Create combined dropdown options
  // const getCombinedLanguageOptions = () => {
  //   const options = [];

  //   // Add UI languages first
  //   uiLanguages.forEach(lang => {
  //     options.push({
  //       id: lang.id,
  //       title: lang.title,
  //       type: 'ui'
  //     });
  //   });

  //   // Add question languages if different from UI languages
  //   if (props.state.test_language) {
  //     props.state.test_language.forEach(qLang => {
  //       // Only add if not already in UI languages
  //       if (!uiLanguages.find(ui => ui.id == qLang.id)) {
  //         options.push({
  //           id: qLang.id,
  //           title: qLang.title,
  //           type: 'question'
  //         });
  //       }
  //     });
  //   }

  //   return options;
  // };

  return (
    <>
    {/* {console.log("[STEP 5] Panel got question:", props.activeQuesData?.question)}
    {console.log("[STEP 0] Props in QuestionPanel", props)} */}

      {show && (
        <Confirm
          is_test_submit_status={
            props.testPanelData.test_settings.is_test_submit_status
          }
          setShow={setShow}
        />
      )}
      {showMadetry && <MandatoryQuestion setshowMadetry={setshowMadetry} />}
      <div
        className={
          props.showDrop == true
            ? width > 870
              ? "questionfield"
              : "hideField"
            : "questionfield"
        }
        style={{
          width: props.drower === false ? "100%" : "calc(100% - 364px)",
        }}
      >
        {/* <div className="questionheader"> */}
        <div
          style={{
            height: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginRight: "12px",
            }}
          >
            <Slider
              subjects_data={props.testPanelData.subjects_data}
              subjectid={subjectid}
              setSubjectId={setSubjectId}
              is_neet_test={props?.state?.test_data?.is_neet_test}
              is_sec_time={props?.state?.test_data?.is_sec_time}
            />
          </div>

          <div className="topaddbutton">
            <button
              style={{
                background: "none",
                outline: "none",
                border: "none",
                color: "green",
              }}
            >
              {t('test.clearResponse')}
            </button>
            <button
              style={{
                background: "none",
                outline: "none",
                border: "none",
                color: "green",
              }}
            >
              {t('test.markForReview')}
            </button>
          </div>
          <div className="questionoptionfield">
            {props.activeQuesData && (
              <QuestionList
                activeQuesData={props.activeQuesData}
                testPanelData={props.testPanelData}
                selectedLanguage={selectedLanguage}

              />
            )}
          </div>
        </div>
        <div className="questionfooter">
          <div>
            {props.state.activeQuesInd > 0 &&
              props.testPanelData.test_settings.is_allow_back_button == 1 && (
                <button
                  className="clearresponsebtn"
                  onClick={() => onPreview()}
                >
                  {t('test.previous')}
                </button>
              )}
            <button
              className="clearresponsebtn"
              onClick={() => ClearResponse()}
            >
              {t('test.clearResponse')}
            </button>
            <button className="markforreview" onClick={() => MarkedForReview()}>
              {t('test.markForReviewNext')}
            </button>
            {props.state.activeQuesInd + 1 < props.state.ques_data.length && (
              <button className="saveandnext" onClick={() => SavendNext()}>
                {t('test.saveAndNext')}
              </button>
            )}
            {props.state.activeQuesInd + 1 === props.state.ques_data.length && (
              <button className="saveandnext" onClick={() => Save()}>
                {t('test.save')}
              </button>
            )}
            <button className="showsubmitbutton" onClick={() => setShow(true)}>
              {t('test.submit')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  state: state,
  languageSelected: state.languageSelected, // ✅ ensures proper binding
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  dispatchChangeLanguage: (e) =>
    dispatch({
      type: "CHANGES_LANGUAGE",
      languageSelected: parseInt(e.target.value),
    }),
});



export default connect(mapStateToProps, mapDispatchToProps)(QuestionPanel);
